export const types = {
    SHIFT_LIGHTS: "map/advanced-operations/shift-lights",
    UPLOAD_JSON_FILE: "map/advanced-operations/upload-json-file",
};

export default {
    shiftLights: (x, y) => ({
        type: types.SHIFT_LIGHTS,
        payload: { x, y },
    }),
    uploadJsonFile: (file) => ({
        type: types.UPLOAD_JSON_FILE,
        payload: { file },
    }),
};
